// extracted by mini-css-extract-plugin
module.exports =  {"popover-box":"bd4zU0u","popoverBox":"bd4zU0u"};